function onLayerReady(layerProvider, layerId, callback, options) {
  return layerProvider.getLayerAsync(layerId, function (layer) {
    return layer.onReady(callback, options);
  });
}

export { onLayerReady as default };
